import { onMounted, onBeforeUnmount } from "vue";
export function useScreenSaverPrevention() {
  let screenWakeLock = null;
  onMounted(async () => {
    await requestWakeLock();
  });
  onBeforeUnmount(async () => {
    await releaseWakeLock();
  });
  async function requestWakeLock() {
    if ("wakeLock" in navigator) {
      try {
        screenWakeLock = await navigator.wakeLock.request("screen");
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    }
  }
  async function releaseWakeLock() {
    if (!screenWakeLock) {
      return;
    }
    try {
      await screenWakeLock.release();
      screenWakeLock = null;
    } catch (err) {
      console.error(`${err.name}, ${err.message}`);
    }
  }
  return {
    requestWakeLock,
    releaseWakeLock
  };
}
